<template>
    <div class="container py-4">
        <div class="card card-default shadow-sm mb-5">
            <div class="card-header border-bottom">
                <h5 class="header-title">Marketplace Partners</h5>
                <p class="text-muted mb-2">
                    Select the product you need more information about. All GuestFlip partners can benefit from exclusive discounts and promotions.
                </p>
            </div>
            <div class="card-body">
                <form @submit.prevent="submitForm">
                    <div class="row">
                        <div v-for="(partner, index) in partners" :key="index" class="col-md-6">
                            <div class="partner-card-wrapper position-relative w-100 d-flex align-items-stretch"
                                :class="{ selected: isSelected(partner.name) }" @click="togglePartner(partner.name)">
                                <input type="checkbox" class="d-none partner-checkbox" :value="partner.name"
                                    v-model="selectedPartners" />

                                <div class="aside-icon d-flex justify-content-center align-items-center"
                                    :class="isSelected(partner.name) ? 'bg-primary text-white' : 'bg-light'">
                                    <i class="fas fa-check fa-lg"></i>
                                </div>

                                <div
                                    class="card partner-card w-100 h-100 border d-flex flex-grow-1 align-items-center p-3 position-relative mb-0">
                                    <div class="w-100 pl-3">
                                        <h6 class="mb-1">
                                            <span data-toggle="tooltip" :title="partner.description">
                                                {{ partner.name }}
                                                <i class="fas fa-info-circle text-muted ml-1"></i>
                                            </span>
                                        </h6>
                                        <p class="text-muted small mb-2" v-if="partner.description">
                                            {{ partner.description }}
                                        </p>
                                        <a href="#" class="text-primary small" @click.prevent="showModal(index)">
                                            Discover More
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <!-- Bootstrap Modal -->
                            <div class="modal fade" :id="'partnerModal_' + index" tabindex="-1" role="dialog"
                                :aria-labelledby="'partnerModalLabel_' + index" aria-hidden="true">
                                <div class="modal-dialog full-width modal-dialog-centered" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" :id="'partnerModalLabel_' + index">
                                                {{ partner.name }}
                                            </h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <iframe v-if="partner.pdf" :src="partner.pdf" width="100%" height="600px"></iframe>
                                        <img v-else-if="partner.image" :src="partner.image" class="img-fluid mb-3" alt="Partner Image" />

                                        <div class="modal-body">
                                            <p v-html="partner.long_description || partner.description"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr class="my-4" />

                    <h5 class="header-title">Contact Form</h5>

                    <div class="form-group">
                        <label>Your Name: <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="form.contact_name" required />
                    </div>

                    <div class="form-group">
                        <label>Email <span class="text-danger">*</span></label>
                        <input type="email" class="form-control" v-model="form.email" required disabled />
                    </div>

                    <div class="form-group">
                        <label>Hotel Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="form.hotel_name" required />
                    </div>

                    <div class="form-group">
                        <label>Location <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="form.location" required />
                    </div>

                    <div class="form-group">
                        <label>Number of Rooms <span class="text-danger">*</span></label>
                        <input type="number" min="1" class="form-control" v-model="form.rooms" required />
                    </div>

                    <div class="form-group">
                        <label>Other Information</label>
                        <textarea class="form-control" rows="4" v-model="form.other_info"></textarea>
                    </div>

                    <button type="submit" class="btn btn-primary">Send Request</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        partners: Array,
    },
    mounted() {
        this.$nextTick(() => {
            // Reinitialize tooltips when DOM is fully rendered
            $(this.$el).find('[data-toggle="tooltip"]').tooltip();
        });
    },
    data() {
        return {
            selectedPartners: [],
            form: {
                contact_name: (Spark.state?.user?.name) || '',
                email: (Spark.state?.user?.email) || '',
                hotel_name: (Spark.state.currentTeam?.name) || '',
                location: '',
                rooms: '',
                other_info: ''
            }
        };
    },
    methods: {
        isSelected(name) {
            return this.selectedPartners.includes(name);
        },
        togglePartner(name) {
            const index = this.selectedPartners.indexOf(name);
            if (index >= 0) {
                this.selectedPartners.splice(index, 1);
            } else {
                this.selectedPartners.push(name);
            }
        },
        showModal(index) {
            $(`#partnerModal_${index}`).modal('show');
        },
        submitForm() {
            axios.post('/api/marketplace/contact', {
                name: this.form.contact_name,
                email: this.form.email,
                hotel_name: this.form.hotel_name,
                location: this.form.location,
                rooms: this.form.rooms,
                other_info: this.form.other_info,
                selected_partners: this.selectedPartners
            })
                .then(() => {
                    swal('Success!', 'Your request has been sent successfully.', 'success');
                    this.form.location = '';
                    this.form.rooms = '';
                    this.form.other_info = '';
                    this.selectedPartners = [];
                })
                .catch(error => {
                    let message = 'Something went wrong. Please check your input and try again.';
                    if (error.response && error.response.data && error.response.data.errors) {
                        message = Object.values(error.response.data.errors).flat().join('\n');
                    }
                    swal('Oops!', message, 'error');
                });
        }

    }
};
</script>

<style scoped>
.partner-card-wrapper {
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    margin-bottom: 1rem;
    border-left: 5px solid transparent;
}

.partner-card-wrapper:hover .aside-icon {
    background-color: #00acf0 !important;
    color: white !important;
    transition: background-color 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.aside-icon {
    width: 48px;
    transition: all 0.3s ease-in-out;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    font-size: 1.25rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 30, 0.1), 0 2px 4px 0 rgba(0, 0, 30, 0.1);
}

.partner-card {
    background-color: #f8f9fa;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    margin-bottom: 0 !important;
    border-left: 0 !important;
    border-top-left-radius: 0%;
    border-bottom-left-radius: 0%;
    border-left-width: 0 !important;
}

.partner-card-wrapper.selected .partner-card {
    background-color: #ffffff;
}

.partner-card-wrapper:hover .partner-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
}

.aside-icon i {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.partner-card-wrapper:hover .aside-icon i {
    transform: scale(1.2);
    opacity: 1;
}
</style>